<header class="mini-top-header">
  <div class="container">
    <a href="https://web.facebook.com/togamas/?_rdc=1&_rdr" target="blank">
      <p class="d-flex align-items-center">
        <i class="ri-facebook-fill"></i>
        Togamas
      </p>
    </a>
    <a href="https://www.instagram.com/togamasdotcom/?hl=en" target="blank">
      <p class="d-flex align-items-center">
        <i class="ri-instagram-line"></i>
        @togamasdotcom
      </p>
    </a>
    <a href="https://twitter.com/togamas?lang=en" target="blank">
      <p class="d-flex align-items-center">
        <i class="ri-twitter-line align-bottom"></i>
        @togamas
      </p>
    </a>
    <a
      href="https://www.tiktok.com/@togamas_com?is_from_webapp=1&sender_device=pc"
      target="blank"
    >
      <p class="d-flex align-items-center">
        <img
          src="/tiktok.png"
          alt=""
          style="filter: brightness(0) invert(1); width: 14px; height: 14px"
          class="mx-1"
        />
        @togamas_com
      </p>
    </a>
    <a href="https://wa.me/628123312323" target="blank">
      <p class="d-flex align-items-center">
        <i class="ri-whatsapp-line"></i>
        togamas
      </p>
    </a>
  </div>
</header>
